import Hire from './Hire';

export default Hire;
